import React from "react";
import find from "lodash/find";
import { clearError } from "../form/errors";

const $ticketRequestTypeSelect = document.querySelector(
  "#ticket_request_type_field[data-request-types]"
);
const requestTypes = JSON.parse($ticketRequestTypeSelect.dataset.requestTypes);
const dataPlaceholder = $ticketRequestTypeSelect.dataset.placeholder;
const selectedRequestTypeId =
  parseInt($ticketRequestTypeSelect.dataset.selectedRequestTypeId) || null;
class RequestTypeSelect extends React.Component {
  constructor(props) {
    super(props);
    this.handleRequestTypeSelected(this.defaultSelectOption());
  }

  handleChange({ target }) {
    this.handleRequestTypeSelected(parseInt(target.value));
    clearError(target);
  }

  handleRequestTypeSelected(requestTypeId) {
    const requestType = find(requestTypes, (type) => type.id === requestTypeId);
    this.props.onRequestTypeSelected(requestType);
  }

  defaultSelectOption() {
    if (selectedRequestTypeId) return selectedRequestTypeId;
    if (requestTypes.length === 1) return requestTypes[0].id;

    return null;
  }

  render() {
    return (
      <div>
        <select
          name="ticket[request_type_id]"
          defaultValue={this.defaultSelectOption()}
          onChange={this.handleChange.bind(this)}
        >
          {requestTypes.length > 1 && <option value="">{dataPlaceholder}</option>}
          {requestTypes.map(({ id, code, name }) => {
            return (
              <option key={name} value={id} data-code={code}>
                {name}
              </option>
            );
          })}
        </select>
        <div className="help"></div>
      </div>
    );
  }
}

export default RequestTypeSelect;
